import React, { useEffect, useRef } from 'react';
import { useHandleSignInCallback } from '@logto/react';
import { Loader2 } from 'lucide-react';
import { api } from '../../utils/api';
import { createLoginCallbackFunnelEvent } from '../../utils/authFunnel';

const AuthCallback = () => {
  const errorTrackedRef = useRef(false);
  const { isLoading, error } = useHandleSignInCallback(() => {
    const event = createLoginCallbackFunnelEvent();
    void api.trackFunnelEvent(event.eventName, event.payload);

    // Redirect to intended path or home after successful login
    const intendedPath = sessionStorage.getItem('intendedPath') || '/';
    sessionStorage.removeItem('intendedPath');
    window.location.href = intendedPath;
  });

  useEffect(() => {
    if (error && !errorTrackedRef.current) {
      errorTrackedRef.current = true;
      const event = createLoginCallbackFunnelEvent({ error });
      void api.trackFunnelEvent(event.eventName, event.payload);
      console.error('Auth callback error:', error);
      // Redirect to home with error
      setTimeout(() => {
        window.location.href = '/?error=auth_failed';
      }, 3000);
    }
  }, [error]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
          <div className="text-center">
            <div className="text-red-500 mb-4">
              <svg className="mx-auto h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Authentication Failed</h2>
            <p className="text-gray-600 mb-4">
              There was an error during the authentication process.
            </p>
            <p className="text-sm text-gray-500">
              Redirecting you back to the home page...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="text-center">
          <div className="text-blue-500 mb-4">
            <Loader2 className="mx-auto h-12 w-12 animate-spin" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Signing you in</h2>
          <p className="text-gray-600">
            Please wait while we complete your authentication...
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
